import { useState} from "react";
import { createTheme, Dialog, TableHead, ThemeProvider, Typography, Box, Table, TableRow, TableBody, TableCell } from "@mui/material";
import HelpIcon from '@mui/icons-material/Help';
import { Translate, translate } from 'react-i18nify';


export default function InstallerLookupFilterExplainer(props) {
    const [open, setOpen] = useState(false);

    const toggleHelp = () => {
        setOpen(old => !old);
    };
    
    return (
        <Box sx={{cursor: "pointer" }} >
            <HelpIcon  onClick={toggleHelp} sx={{mr: {md:3, xs: 28}, color: "primary.main"}} />
            <ExplainerDialog open={open} setOpen={setOpen} remarks={props.remarks} />
        </Box>
    );
}

function ExplainerDialog (props) {

    if(props.open === false)
        return null

    const theme = createTheme({
        typography: {
            body1: {
                fontSize: 15,
            },
            h5:{
                fontSize: 20,
                fontWeight: "bold"
            },
            h3: {
                fontSize: 40,
                fontWeight: "bold"
            }
        },
        components: {

        }
    })

    return(
        <Dialog
            fullWidth
            maxWidth="md"
            sx={{ width: "100%", p: 0,}}
            open={props.open}
            onClose={() => props.setOpen(false)}
        >
            <ThemeProvider theme={theme} >
                <Box sx={{ m:3 }} >
                <Box id={"HeaderBox"} sx={{ m:1.5, mb:5 }} >
                <Typography variant="h3" >
                    <Translate value="RemarkHierExplainer.Header" />
                </Typography>
                <br/>
                <Typography variant="h5" >
                    <Translate value="RemarkHierExplainer.Body1" />
                </Typography>
                <Typography variant="h5" >
                    <Translate value="RemarkHierExplainer.Body2" />
                </Typography>
                <Typography variant="h5" >
                    <Translate value="RemarkHierExplainer.Body3" />
                </Typography>
                </Box>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <Typography variant="h5" >
                                <Translate value="RemarkTableHeaders.Remark" />     
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant="h5" >
                                <Translate value="RemarkTableHeaders.Explanation" />
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant="h5" >
                                <Translate value="RemarkTableHeaders.RecommendedAction" />
                                </Typography>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.remarks.map((remark,index) => {
                            return(
                                <TableRow key={index} >
                                <TableCell width={"40%"} >
                                    <Typography variant="body1"><b>{`${translate(remark.name)}`}</b></Typography>
                                </TableCell>
                                <TableCell >
                                    <Typography variant="body1">{`${translate(remark.explainer)}`} </Typography>
                                </TableCell>
                                {remark.recommendedAction !== "" ? 
                                    <TableCell>
                                        <Typography variant="body1">{`${translate(remark.recommendedAction)}`} </Typography>
                                    </TableCell>
                                :
                                    <TableCell></TableCell>
                                }
                            </TableRow>)
                        })}
                    </TableBody>
                </Table>
            </Box>
            </ThemeProvider>
        </Dialog>
    )
}